/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Op_ContainsInputs */

const cs_op_contains = /** @type {(inputs: Op_ContainsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`obsahuje`)
};

const en_op_contains = /** @type {(inputs: Op_ContainsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`contains`)
};

/**
* | output |
* | --- |
* | "contains" |
*
* @param {Op_ContainsInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const op_contains = /** @type {((inputs?: Op_ContainsInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Op_ContainsInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_op_contains(inputs)
	return cs_op_contains(inputs)
});